function calMeasurement(width, height, qty, name, type) {
  if (
    $(`select[name="properties[Single Panel Width Before Pleats Made (inch)]"],
        select[name="properties[Single Panel Width After Pleats Made (inch)]"]`)
      .length > 0
  ) {
    $(
      `select[name="properties[Single Panel Width Before Pleats Made (inch)]"]`
    ).val(width);
  }
  if (
    $(`select[name="properties[Single Panel Width After Pleats Made (inch)]"]`)
      .length > 0
  ) {
    $(
      `select[name="properties[Single Panel Width After Pleats Made (inch)]"]`
    ).val(width);
  }
  if ($(`select[name="properties[Single Panel Width (inch)]"]`).length > 0) {
    $(`select[name="properties[Single Panel Width (inch)]"]`).val(width);
  }

  if ($(`select[name="properties[Single Panel Width(inch)]"]`).length > 0) {
    $(`select[name="properties[Single Panel Width(inch)]"]`).val(width);
  }

  if (
    $(`select[name="properties[Finished Length/Height (Inch)]"]`).length > 0
  ) {
    $(`select[name="properties[Finished Length/Height (Inch)]"]`).val(height);
  }
  if (
    $(`select[name="properties[Single Panel Length/Height (inch)]"]`).length > 0
  ) {
    $(`select[name="properties[Single Panel Length/Height (inch)]"]`).val(
      height
    );
  }
  if (
    $(`select[name="properties[Finished Length/Height (inch)]"]`).length > 0
  ) {
    $(`select[name="properties[Finished Length/Height (inch)]"]`).val(height);
  }

  if (
    $(`select[name="properties[Finished Length/Height (Inch):  ]"]`).length > 0
  ) {
    $(`select[name="properties[Finished Length/Height (Inch):  ]"]`).val(
      height
    );
  }

  $(`input[name="properties[Hanging Header Style]"][value="${name}"]`).prop(
    "checked",
    true
  );

  console.log(
    $(`input[name="properties[Hanging Header Style]"]`),
    name,
    "shdahd"
  );
  var element2 = "";
  var element_3 = document.querySelector(
    'input[name="properties[Hanging Header Style]"]'
  );
  var element = document.querySelector(
    'select[name="properties[Single Panel Width Before Pleats Made (inch)]"]'
  );
  setTimeout(function () {
    // 触发改变事件
    if (element_3.dispatchEvent) {
      // 创建一个改变事件对象
      var event_3 = new Event("change", {
        bubbles: true,
        cancelable: true,
      });

      // 分发事件
      element_3.dispatchEvent(event_3);
    } else {
      // IE浏览器的事件触发方式
      element_3.fireEvent("onchange");
    }
  }, 10);

  setTimeout(function () {
    // 触发改变事件
    if (element.dispatchEvent) {
      // 创建一个改变事件对象
      var event = new Event("change", {
        bubbles: true,
        cancelable: true,
      });

      // 分发事件
      element.dispatchEvent(event);
    } else {
      // IE浏览器的事件触发方式
      element.fireEvent("onchange");
    }
  }, 20);

  setTimeout(function () {
    if (
      $(`select[name="properties[Finished Length/Height (Inch)]"]`).length > 0
    ) {
      element2 = document.querySelector(
        'select[name="properties[Finished Length/Height (Inch)]"]'
      );
    }

    console.log(
      $(`select[name="properties[Finished Length/Height (Inch):  ]"]`).length,
      "212"
    );
    if (
      $(`select[name="properties[Finished Length/Height (Inch):  ]"]`).length >
      0
    ) {
      element2 = document.querySelector(
        'select[name="properties[Finished Length/Height (Inch):  ]"]'
      );
    }

    console.log(element2, "element2");
    // 触发改变事件
    if (element2.dispatchEvent) {
      // 创建一个改变事件对象
      var event2 = new Event("change", {
        bubbles: true,
        cancelable: true,
      });

      // 分发事件
      element2.dispatchEvent(event2);
    } else {
      // IE浏览器的事件触发方式
      element2.fireEvent("onchange");
    }
    $("input[data-quantity-value]").val(qty);
  }, 30);
  if (type == "load") {
    setTimeout(function () {
      // 触发改变事件
      if (element.dispatchEvent) {
        // 创建一个改变事件对象
        var event = new Event("change", {
          bubbles: true,
          cancelable: true,
        });

        // 分发事件
        element.dispatchEvent(event);
      } else {
        // IE浏览器的事件触发方式
        element.fireEvent("onchange");
      }
    }, 4000);
  }
}

$(document).ready(function () {
  let hasCbbStatus = false,
    initBuildCbbTime = "",
    hasCbbTime = 500;

  initBuildCbbTime = window.setInterval(() => {
    hasCbbTime += 500;
    if (hasCbbTime == 40000) {
      window.clearInterval(initBuildCbbTime);
    }
    if ($("body").has("#bcpo").length != 0) {
      // 获取localStorage中的measurementProductResult数据
      var jsonString = localStorage.getItem("measurementProductResult");

      // 将JSON字符串转换为JavaScript对象
      var result = JSON.parse(jsonString);

      // 输出结果
      console.log(result);
      let roundedWidth =
        result.width % 1 <= 0.4
          ? parseInt(result.width)
          : Math.ceil(result.width);
      let roundedHeight =
        result.height % 1 <= 0.4
          ? parseInt(result.height)
          : Math.ceil(result.height);
      calMeasurement(
        roundedWidth,
        roundedHeight,
        result.qty,
        result.name,
        "load"
      );
      window.clearInterval(initBuildCbbTime);
    }
  }, 500);
});
